// src/features/tasks/services/tasks.js
import { apiClient } from '../../../services/api/client';

export const tasksAPI = {
  // Task Categories
  createTaskCategory: (data) => 
    apiClient.post('/api/v1/task-management/categories/', data),
  
  getTaskCategories: (params = {}) => 
    apiClient.get('/api/v1/task-management/categories/', { params }),
  
  getTaskCategoryDetails: (categoryId) => 
    apiClient.get(`/api/v1/task-management/categories/${categoryId}`),
  
  updateTaskCategory: (categoryId, data) => 
    apiClient.put(`/api/v1/task-management/categories/${categoryId}`, data),
  
  deleteTaskCategory: (categoryId, params = {}) => 
    apiClient.delete(`/api/v1/task-management/categories/${categoryId}`, { params }),
  
  deactivateTaskCategory: (categoryId) => 
    apiClient.patch(`/api/v1/task-management/categories/${categoryId}/deactivate`),
  
  activateTaskCategory: (categoryId) => 
    apiClient.patch(`/api/v1/task-management/categories/${categoryId}/activate`),

  // Tasks
  createTask: (data) => 
    apiClient.post('/api/v1/task-management/tasks/', data),
  
  getDepartmentTasks: (params = {}) => 
    apiClient.get('/api/v1/task-management/tasks/', { params }),
  
  getMyTasks: (params = {}) => 
    apiClient.get('/api/v1/task-management/tasks/me', { params }),
  
  getMySecondaryTasks: (params = {}) => 
    apiClient.get('/api/v1/task-management/tasks/me/secondary', { params }),
  
  getAllMyTasks: () => 
    apiClient.get('/api/v1/task-management/tasks/me/all'),
  
  getMyTodaysTasks: () => 
    apiClient.get('/api/v1/task-management/tasks/me/today'),
  
  getCategoryTasks: (categoryId, params = {}) => 
    apiClient.get(`/api/v1/task-management/tasks/category/${categoryId}`, { params }),
  
  getTodaysTasks: () => 
    apiClient.get('/api/v1/task-management/tasks/today'),
  
  getOverdueTasks: (params = {}) => 
    apiClient.get('/api/v1/task-management/tasks/overdue', { params }),
  
  getCalendarTasks: (params) => 
    apiClient.get('/api/v1/task-management/tasks/calendar', { params }),
  
  searchTasks: (params) => 
    apiClient.get('/api/v1/task-management/tasks/search', { params }),
  
  filterTasks: (data) =>
    apiClient.post('/api/v1/task-management/tasks/filter', data),

  getHomeTasks: () =>
    apiClient.get('/api/v1/task-management/tasks/home'),
  
  getTaskStatistics: () => 
    apiClient.get('/api/v1/task-management/tasks/statistics'),
  
  getCategoryTaskStatistics: (categoryId) => 
    apiClient.get(`/api/v1/task-management/tasks/statistics/category/${categoryId}`),
  
  getTaskDetails: (taskId) => 
    apiClient.get(`/api/v1/task-management/tasks/${taskId}`),
  
  updateTask: (taskId, data) => 
    apiClient.put(`/api/v1/task-management/tasks/${taskId}`, data),
  
  deleteTask: (taskId) =>
    apiClient.delete(`/api/v1/task-management/tasks/${taskId}`),

  copyTask: (taskId) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/copy`),

  // Task State Management
  startTask: (taskId, data = {}) => 
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/start`, data),
  
  putTaskOnHold: (taskId, data = {}) => 
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/hold`, data),
  
  resumeTask: (taskId, data = {}) => 
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/resume`, data),
  
  cancelTask: (taskId, data = {}) => 
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/cancel`, data),
  
  completeTask: (taskId, data = {}) => 
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/complete`, data),
  
  markTaskNotCompleted: (taskId, data = {}) =>
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/not-complete`, data),

  reopenTask: (taskId, data = {}) =>
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/state/reopen`, data),

  getValidTransitions: (taskId) =>
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/state/transitions`),

  scheduleNextRecurringTask: (taskId) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/state/schedule-next`, {}),

  getLastCompletion: (taskId) =>
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/last-completion`),
};